<!-- eslint-disable vue/no-v-html -->
<template>
  <div id="skin-analysis-view">
    <div v-if="debugFlag" class="debug-tools-loading">
      <div v-if="doneEvent1">skinAnalysisStarted</div>
      <div v-if="doneEvent2">skinAnalysisProgressUpdated</div>
      <div v-if="doneEvent3">skinAnalysisUpdated</div>
      <div v-if="doneEvent4">skinAnalysisCompleted</div>
      <div v-if="doneEvent5">closed</div>
    </div>
    <SkinAnalysisLoading
      v-if="isLoading"
      :account-id="accountId"
      :progress="loadingProgress"
      :trivia-master="masterData.trivia"
      :all-data="allData"
    />
    <SkinAnalysisFailedDialog v-if="isFailed" :account-id="accountId" />
    <div id="YMK-module-wrapper" ref="ymkModuleWrapper">
      <button
        v-if="result && skinTypeId && isShowAppLinkButton"
        type="button"
        class="app-link-button"
        @click="clickedAppLinkButton"
      ></button>

      <div v-if="debugFlag" class="failed-checkbox-container">
        <!-- debug用 -->
        <input id="failed-checkbox" v-model="failedDebug" type="checkbox" />
        <label for="failed-checkbox">肌分析の失敗パターン</label>
      </div>
      <div id="YMK-module"></div>
      <div v-if="result" class="feature-indicator-container-wrapper">
        <div class="feature-indicator-container">
          <template v-if="selectedFeature === 'firmness'">
            <div
              class="firmness-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(0)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.firmness.upper") }}
            </div>
            <div
              class="firmness-indicator-bottom-img indicator-bottom-img"
            ></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.firmness.bottom") }}
            </div>
          </template>
          <template v-if="selectedFeature === 'wrinkles'">
            <div
              class="wrinkles-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(1)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.wrinkles.upper") }}
            </div>
            <div
              class="wrinkles-indicator-bottom-img indicator-bottom-img"
            ></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.wrinkles.bottom") }}
            </div>
          </template>
          <template v-if="selectedFeature === 'darkCirclesV2'">
            <div
              class="darkCirclesV2-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(2)"
            ></div>
          </template>
          <template v-if="selectedFeature === 'pore'">
            <div
              class="pore-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(3)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.pore.upper") }}
            </div>
            <div class="pore-indicator-bottom-img indicator-bottom-img"></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.pore.bottom") }}
            </div>
          </template>
          <template v-if="selectedFeature === 'texture'">
            <div
              class="texture-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(4)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.texture.upper") }}
            </div>
            <div
              class="texture-indicator-bottom-img-1 indicator-bottom-img-1"
            ></div>
            <div
              class="texture-indicator-bottom-img-2 indicator-bottom-img-2"
            ></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.texture.bottom") }}
            </div>
          </template>
          <template v-if="selectedFeature === 'ageSpots'">
            <div
              class="ageSpots-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(5)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.ageSpots.upper") }}
            </div>
            <div
              class="ageSpots-indicator-bottom-img indicator-bottom-img"
            ></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.ageSpots.bottom") }}
            </div>
          </template>
          <template v-if="selectedFeature === 'moisture'">
            <div
              class="moisture-indicator-upper-img indicator-upper-img"
              :style="getIndicatorStyle(6)"
            ></div>
            <div class="indicator-bottom-label-1">
              {{ $t("skinAnalysis.levelMeter.moisture.upper") }}
            </div>
            <div
              class="moisture-indicator-bottom-img indicator-bottom-img"
            ></div>
            <div class="indicator-bottom-label-2">
              {{ $t("skinAnalysis.levelMeter.moisture.bottom") }}
            </div>
          </template>
        </div>
      </div>
      <div v-if="result" class="skin-care-feature-tab-container">
        <ul class="skin-care-feature-tab-list">
          <li class="tab-item">
            <div
              class="firmness-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'firmness' }"
              @keydown="selectFeature('firmness')"
              @click="selectFeature('firmness')"
            >
              {{ result.firmness }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.firmness')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="wrinkles-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'wrinkles' }"
              @keydown="selectFeature('wrinkles')"
              @click="selectFeature('wrinkles')"
            >
              {{ result.wrinkles }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.wrinkles')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="darkCirclesV2-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'darkCirclesV2' }"
              @keydown="selectFeature('darkCirclesV2')"
              @click="selectFeature('darkCirclesV2')"
            >
              {{ result.darkCirclesV2 }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.darkCirclesV2')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="pore-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'pore' }"
              @keydown="selectFeature('pore')"
              @click="selectFeature('pore')"
            >
              {{ result.pore }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.pore')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="texture-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'texture' }"
              @keydown="selectFeature('texture')"
              @click="selectFeature('texture')"
            >
              {{ result.texture }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.texture')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="ageSpots-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'ageSpots' }"
              @keydown="selectFeature('ageSpots')"
              @click="selectFeature('ageSpots')"
            >
              {{ result.ageSpots }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.ageSpots')"
            ></div>
          </li>
          <li class="tab-item">
            <div
              class="moisture-tab-button feature-tab-button"
              :class="{ active: selectedFeature === 'moisture' }"
              @keydown="selectFeature('moisture')"
              @click="selectFeature('moisture')"
            >
              {{ result.moisture }}
            </div>
            <div
              class="feature-tab-label"
              v-html="$t('skinAnalysis.labelsWithBr.moisture')"
            ></div>
          </li>
        </ul>
      </div>
    </div>

    <!-- デバッグ用 -->
    <div v-if="debugFlag" class="debug-tools-score">
      デバッグ用 スコアを入力
      <div
        v-for="item in debugFeature"
        :key="item.key"
        class="debug-input-score"
      >
        <div :id="`${item.key}`" class="debug-input-container">
          <label :for="`${item.key}-input`">{{ item.name }}</label>
          <select :id="`${item.key}-input`" v-model="item.val">
            <option v-for="score in 100" :key="score" :value="score">
              {{ score }}
            </option>
          </select>
        </div>
      </div>
      <button class="update-score" type="button" @click="updateScore">
        適用
      </button>
    </div>

    <template v-if="result && skinTypeId">
      <SkinAnalysisResultView
        :account-id="accountId"
        :result="result"
        :skin-type-id="skinTypeId"
        :master-data="masterData"
        :all-data="allData"
        :is-error="isError"
      />
    </template>
  </div>
</template>

<script>
import SkinAnalysisLoading from "../components/SkinAnalysisLoading.vue";
import SkinAnalysisFailedDialog from "../components/SkinAnalysisFailedDialog.vue";
import SkinAnalysisResultView from "./SkinAnalysisResultView.vue";
import consoleController from "../utils/logUtil";
import skinTypeAlgorithm from "@/algorithms/skinTypeAlgorithm";
import fetchAPI from "@/utils/fetch";
import errorUtil from "@/utils/errorUtil";
import store from "@/utils/store";
import constant from "@/const";

export default {
  components: {
    SkinAnalysisLoading,
    SkinAnalysisFailedDialog,
    SkinAnalysisResultView,
  },
  data() {
    return {
      accountId: undefined,
      listeners: [],
      result: undefined,
      skinTypeId: undefined,
      selectedFeature: "firmness",
      failedDebug: false,
      isFailed: false,
      isLoading: false,
      loadingTimer: null,
      isResponseReceived: false,
      loadingProgress: 0,
      // マスタデータ
      masterData: undefined,
      // 肌分析ブラウザ作成に必要なアカウントに紐づく全情報
      allData: undefined,
      // fetchでネットワークエラー ダイアログ表示済み
      isError: false,
      // モジュールロード判定タイムアウトID
      moduleLoadTimeoutId: undefined,
      // アプリ起動ボタンを表示
      isShowAppLinkButton: false,

      // 多言語画像のURL保持
      i18n_indicator_upper_text_png: {
        0: { url: "", ratio: 369 / 99 },
        1: { url: "", ratio: 369 / 99 },
        2: { url: "", ratio: 369 / 99 },
        3: { url: "", ratio: 369 / 99 },
        4: { url: "", ratio: 369 / 99 },
        5: { url: "", ratio: 369 / 99 },
        6: { url: "", ratio: 369 / 99 },
      },

      // デバッグ用
      debugFeature: [
        { key: "firmness", name: "ハリ", val: 100 },
        { key: "wrinkles", name: "乾燥小じわ", val: 100 },
        { key: "darkCirclesV2", name: "目もとの明るさ", val: 100 },
        { key: "pore", name: "毛穴の目立ち", val: 100 },
        { key: "texture", name: "なめらかさ", val: 100 },
        { key: "ageSpots", name: "肌全体の明るさ", val: 100 },
        { key: "moisture", name: "うるおい", val: 100 },
      ],
      debugSkinAge: 100,
      debugUpdateResult: [],

      // デバッグ用のフラグ trueの時デバッグ用の画面を表示
      debugFlag: false,
      doneEvent1: false,
      doneEvent2: false,
      doneEvent3: false,
      doneEvent4: false,
      doneEvent5: false,
    };
  },
  computed: {
    cssVars() {
      return {
        "--firmness-indicator-upper-img": this.$getI18nImage(
          "0_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("0_indicator_upper_text")})`
          : "none",
        "--wrinkles-indicator-upper-img": this.$getI18nImage(
          "1_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("1_indicator_upper_text")})`
          : "none",
        "--darkCirclesV2-indicator-upper-img": this.$getI18nImage(
          "2_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("2_indicator_upper_text")})`
          : "none",
        "--pore-indicator-upper-img": this.$getI18nImage(
          "3_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("3_indicator_upper_text")})`
          : "none",
        "--texture-indicator-upper-img": this.$getI18nImage(
          "4_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("4_indicator_upper_text")})`
          : "none",
        "--ageSpots-indicator-upper-img": this.$getI18nImage(
          "5_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("5_indicator_upper_text")})`
          : "none",
        "--moisture-indicator-upper-img": this.$getI18nImage(
          "6_indicator_upper_text",
        )
          ? `url(${this.$getI18nImage("6_indicator_upper_text")})`
          : "none",
      };
    },

    getIndicatorStyle() {
      return (index) => {
        const ratio =
          this.i18n_indicator_upper_text_png[index]?.ratio || 369 / 99;

        return {
          ...this.cssVars,
          "--ratio": ratio,
        };
      };
    },
  },
  watch: {
    // 言語変更を監視
    $currentLocale() {
      this.loadImages();
    },
  },
  created() {},
  async mounted() {
    // TODO: データ取得完了前に結果画面が表示されるケースがないか調査
    const fetchDataFunctions = [];
    if (this.$route.query.accountId) {
      this.accountId = this.$route.query.accountId;
      if (this.accountId !== constant.GUEST_ACCOUNT_ID) {
        fetchDataFunctions.push(this.getAllData());
      }
    }
    fetchDataFunctions.push(this.getMasterData());

    await Promise.all(fetchDataFunctions);
    if (!this.isError) {
      if (window.YMK) {
        this.initYMK();
      } else {
        window.ymkAsyncInit = () => {
          this.initYMK();
        };
        this.loadYMKScript();
      }
    }

    // 初回画像読み込み
    this.loadImages();
    // 国コード「指定なし」(日本)の場合のみ表示
    // それ以外の国ではモジュールが表示する戻るボタンが表示される
    if (store.currentCountry.value === constant.DEFAULT_COUNTRY) {
      this.isShowAppLinkButton = true;
    }
  },
  beforeUnmount() {
    consoleController("log", "【beforeUnmount】");
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    this.closeYMK();
  },
  methods: {
    async getMasterData() {
      const { fetch } = fetchAPI;
      const path = "/web/master/skin-analysis";
      let queryParams = null;
      const lang = store.getUrlLang();
      if (lang !== "") {
        queryParams = {
          lang,
        };
      }
      try {
        const res = await fetch.fetchAPI("GET", path, queryParams);
        if (res !== undefined && res.status === 200) {
          const masterData = await res.json();
          if (!masterData.machine) {
            consoleController("error", "get machine master is failed");
          }
          if (!masterData.careMode) {
            consoleController("error", "get careMode master is failed");
          }
          if (!masterData.skinType) {
            consoleController("error", "get skinType master is failed");
          }
          if (!masterData.skinAnalysisRecommendMachine) {
            this.skinAnalysisRecommendMachineMaster = consoleController(
              "error",
              "get skinAnalysisRecommendMachine master is failed",
            );
          }
          if (!masterData.trivia) {
            consoleController("error", "get trivia master is failed");
          }
          this.masterData = masterData;
          consoleController("log", "getMasterData is success");
        } else if (res !== undefined && res.status !== 200) {
          const errorInfo = await res.json();
          consoleController(
            "error",
            `${path} is failed. errorInfo: ${JSON.stringify(
              errorInfo,
              null,
              4,
            )}`,
          );
          if (!this.isError) {
            this.isError = true;
            errorUtil.createErrorDialog(errorInfo);
            this.goToTutorial();
          }
        } else {
          consoleController("error", `${path} is failed.`);
          if (!this.isError) {
            this.isError = true;
            errorUtil.createErrorDialog(undefined);
            this.goToTutorial();
          }
        }
      } catch (e) {
        if (!this.isError) {
          this.isError = true;
          const errorInfo = {
            errorMessage: this.$t(constant.OFFLINE_ERROR_MSG),
            errorCode: "E201-401",
          };
          errorUtil.createErrorDialog(errorInfo);
          consoleController("error", `${path} is failed.`);
          this.goToTutorial();
        }
      }
    },
    async getAllData() {
      const { fetch } = fetchAPI;
      const path = "/web/database-access/get-skin-analysis-all";
      const body = {
        accountId: this.accountId,
      };
      try {
        const res = await fetch.fetchAPI("POST", path, null, body);
        if (res !== undefined && res.status === 200) {
          this.allData = await res.json();
          consoleController("log", "getAllData is success");
        } else if (res !== undefined && res.status !== 200) {
          const errorInfo = await res.json();
          consoleController(
            "error",
            `${path} is failed. errorInfo: ${JSON.stringify(
              errorInfo,
              null,
              4,
            )}`,
          );
          if (!this.isError) {
            this.isError = true;
            errorUtil.createErrorDialog(errorInfo);
            this.goToTutorial();
          }
        } else {
          consoleController("error", `${path} is failed.`);
          if (!this.isError) {
            this.isError = true;
            errorUtil.createErrorDialog(undefined);
            this.goToTutorial();
          }
        }
      } catch (e) {
        consoleController("error", `${path} is failed.`);
        if (!this.isError) {
          this.isError = true;
          const errorInfo = {
            errorMessage: this.$t(constant.OFFLINE_ERROR_MSG),
            errorCode: "E201-401",
          };
          errorUtil.createErrorDialog(errorInfo);
          this.goToTutorial();
        }
      }
    },
    /**
     * 肌分析SDKを読み込むための基本設定
     * 非同期で実行され、完了後にグローバル変数YMKが登録される
     */
    loadYMKScript() {
      consoleController("log", "loadYMKScript()");
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = `${process.env.VUE_APP_YMK_SDK_PATH}?apiKey=${process.env.VUE_APP_YMK_API_KEY}`;
      s.onerror = () => {
        if (!this.isError) {
          this.isError = true;
          const errorInfo = {
            errorMessage: this.$t(constant.OFFLINE_ERROR_MSG),
            errorCode: "E201-401",
          };
          errorUtil.createErrorDialog(errorInfo);
          consoleController(
            "error",
            `${process.env.VUE_APP_YMK_SDK_PATH} is failed.`,
          );
          this.goToTutorial();
        }
      };
      const x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    },
    initYMK() {
      consoleController("log", "initYMK()");
      if (!window.YMK) {
        consoleController("error", `YMK is not defined`);
        return;
      }
      const { ymkModuleWrapper } = this.$refs;
      const ymkWidth = ymkModuleWrapper.offsetWidth;
      const ymkHeight = ymkModuleWrapper.offsetHeight;
      // 画面サイズが変化した場合にレイアウトが崩れるため、固定する
      ymkModuleWrapper.style.width = `${ymkWidth}px`;
      ymkModuleWrapper.style.height = `${ymkHeight}px`;
      this.registerEvents();
      window.YMK.init({
        language: store.getYmkLang(),
        width: ymkWidth,
        height: ymkHeight,
        disableSkinSmoothLevel: true,
        hideButtonsOnResultPage: true, // 項目毎のボタンを隠すか
      });
      window.YMK.openSkincare("capture");
      // モジュールが起動できなかった場合、エラー表示
      this.moduleLoadTimeoutId = setTimeout(() => {
        const el = document.getElementById("YMK-module");
        if (el.childNodes.length === 0) {
          const errorInfo = {
            errorMessage: this.$t(constant.COMMON_SYSTEM_ERROR_MSG),
            errorCode: "E700-401",
          };
          errorUtil.createErrorDialog(errorInfo);
          consoleController("error", `YMK module is failed.`);
          this.removeEvents();
          this.goToTutorial();
        }
      }, 5000);
    },
    registerEvents() {
      consoleController("log", `registerEvents() start`);
      const l0 = window.YMK.addEventListener("opened", () => {
        consoleController("log", "[YMK Event] opened");
        if (this.moduleLoadTimeoutId) {
          clearTimeout(this.moduleLoadTimeoutId);
          this.moduleLoadTimeoutId = undefined;
        }
      });
      const l1 = window.YMK.addEventListener("skinAnalysisStarted", () => {
        this.doneEvent1 = true;
        consoleController("log", "[YMK Event] skinAnalysisStarted");
        // 肌分析モジュール戻るボタンで再起動した時のために、データを初期化
        this.result = undefined;
        this.loadingTimer = null;
        this.isResponseReceived = false;
      });
      const l2 = window.YMK.addEventListener(
        "skinAnalysisProgressUpdated",
        (s) => {
          this.doneEvent2 = true;
          consoleController(
            "log",
            `[YMK Event] skinAnalysisProgressUpdated: ${s} `,
          );
          this.isLoading = true;
          this.loadingProgress = s;
          // 3.0秒間はローディング表示(豆知識情報をユーザーが読めるようにするため)
          if (!this.loadingTimer) {
            this.loadingTimer = setTimeout(() => {
              this.loadingTimer = null;
              if (this.isResponseReceived) {
                this.isLoading = false;
                this.isResponseReceived = false;
              }
            }, 3000);
          }
        },
      );
      const l3 = window.YMK.addEventListener("skinAnalysisUpdated", (r) => {
        this.doneEvent3 = true;
        consoleController("log", "[YMK Event] skinAnalysisUpdated");
        // Updatedは複数回発生する場合があるが初回のみ処理対象とする。
        // 肌分析結果から戻るボタン押下の場合もStartedから始まり、undefinedで初期化されている。
        if (!this.result) {
          // TODO: 肌分析失敗確認用
          if (this.failedDebug) {
            delete r.firmness;
            delete r.pore;
          }
          this.result = r;

          // 肌分析結果が足りない場合はエラー画面を表示
          if (!this.isYMKResponseValid(this.result)) {
            consoleController(
              "error",
              `skin analysis is failed: ${JSON.stringify(
                this.result,
                null,
                4,
              )}`,
            );
            this.isFailed = true;
            return;
          }

          consoleController(
            "log",
            `result: ${JSON.stringify(this.result, null, 4)}`,
          );
          // 2.5秒間はローディング表示
          if (!this.loadingTimer) {
            this.isLoading = false;
          } else {
            this.isResponseReceived = true;
          }
          // 肌タイプの判別
          this.skinTypeId = skinTypeAlgorithm.determineSkinType(this.result);

          // 初期選択項目の設定
          this.selectFeature("firmness");
        }
      });
      const l4 = window.YMK.addEventListener("skinAnalysisCompleted", () => {
        this.doneEvent4 = true;
        consoleController("log", "[YMK Event] skinAnalysisCompleted");
      });
      const l5 = window.YMK.addEventListener("closed", () => {
        this.doneEvent5 = true;
        consoleController("log", "[YMK Event] closed");
        this.removeEvents();
        this.goToTutorial();
      });
      this.listeners.push(l0, l1, l2, l3, l4, l5);
      consoleController("log", `registerEvents() finish`);
    },
    removeEvents() {
      consoleController("log", `removeEvents()`);
      for (const l of this.listeners) {
        window.YMK.removeEventListener(l);
      }
      this.listeners = [];
    },
    closeYMK() {
      if (window.YMK) {
        consoleController("log", `closeYMK()`);
        this.removeEvents();
        window.YMK.close();
      }
      consoleController("log", `closeYMK(). YMK is not defined`);
    },
    // 肌分析モジュールからのレスポンスチェック
    isYMKResponseValid(response) {
      if (
        response.skinAge === undefined ||
        typeof response.skinAge !== "number" ||
        response.skinAge < 1 ||
        response.skinAge > 100
      ) {
        return false;
      }
      if (
        response.firmness === undefined ||
        typeof response.firmness !== "number" ||
        response.firmness < 1 ||
        response.firmness > 100
      ) {
        return false;
      }
      if (
        response.wrinkles === undefined ||
        typeof response.wrinkles !== "number" ||
        response.wrinkles < 1 ||
        response.wrinkles > 100
      ) {
        return false;
      }
      if (
        response.darkCirclesV2 === undefined ||
        typeof response.darkCirclesV2 !== "number" ||
        response.darkCirclesV2 < 1 ||
        response.darkCirclesV2 > 100
      ) {
        return false;
      }
      if (
        response.pore === undefined ||
        typeof response.pore !== "number" ||
        response.pore < 1 ||
        response.pore > 100
      ) {
        return false;
      }
      if (
        response.texture === undefined ||
        typeof response.texture !== "number" ||
        response.texture < 1 ||
        response.texture > 100
      ) {
        return false;
      }
      if (
        response.ageSpots === undefined ||
        typeof response.ageSpots !== "number" ||
        response.ageSpots < 1 ||
        response.ageSpots > 100
      ) {
        return false;
      }
      if (
        response.moisture === undefined ||
        typeof response.moisture !== "number" ||
        response.moisture < 1 ||
        response.moisture > 100
      ) {
        return false;
      }
      return true;
    },
    goToTutorial() {
      this.$router.replace({
        name: "TutorialView",
        query: { accountId: this.accountId },
      });
    },
    selectFeature(feature) {
      // 選択されたタブを有効化
      this.selectedFeature = feature;
      window.YMK.setSkincareResultType(feature);
    },
    clickedAppLinkButton() {
      consoleController("log", "clickedAppLinkButton()");
      const urlScheme = `${constant.FACECARE_APP_SCHEME}skin-analysis`;
      if (this.accountId && this.accountId !== constant.GUEST_ACCOUNT_ID) {
        consoleController("log", `go to App`);
        window.location.href = urlScheme;
      } else {
        consoleController(
          "log",
          `go to AppDownloadGuide because of accountId is undefined`,
        );
        this.$router.replace({
          name: "AppDownloadGuide",
          query: { accountId: this.accountId },
        });
      }
    },

    async loadImages() {
      // このページで使用する画像を並列読み込み
      const keys = ["0", "1", "2", "3", "4", "5", "6"];
      await Promise.all(
        keys.map(async (key) => {
          const url = await this.$loadI18nImage(`${key}_indicator_upper_text`);
          const ratio = await this.getImageAspectRatio(url);
          this.i18n_indicator_upper_text_png[key] = { url, ratio };
        }),
      );
    },
    getImageAspectRatio(url) {
      // 画像のアスペクト比を算出
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img.naturalWidth / img.naturalHeight);
        // 失敗時はデフォルト値
        img.onerror = () => resolve(369 / 99);
        img.src = url;
      });
    },

    // デバッグ用
    updateScore() {
      this.debugUpdateResult = {};
      // 入力された値の取得
      this.debugFeature.forEach((item) => {
        this.debugUpdateResult[item.key] = item.val;
      });
      this.debugUpdateResult.skinAge = this.debugSkinAge;
      // 肌タイプの判別
      this.skinTypeId = skinTypeAlgorithm.determineSkinType(
        this.debugUpdateResult,
      );
      // resultの更新
      this.result = this.debugUpdateResult;
    },
  },
};
</script>

<style>
:root {
  /* 肌分析スコアボタンの一辺の長さ */
  --feature-tab-button-side-length: 60px;
  /* タブボタン下部のラベル表示の高さ */
  --feature-tab-label-height: 24px;
  /* タブボタン下部のpadding(スクロールバーの高さを確保) */
  --feature-tab-padding-bottom: 10px;
  /* タブボタンとタブラベルの間 */
  --feature-tab-while-button-label: 8px;
  /* 肌分析タブの高さ */
  --feature-tab-list-height: calc(
    var(--feature-tab-button-side-length) + var(--feature-tab-label-height) +
      var(--feature-tab-padding-bottom) + var(--feature-tab-while-button-label)
  );
  /* 肌分析モジュール下部の提供文言の高さ */
  --powered-by-perfect-height: 20px;
}

#skin-analysis-view {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  min-height: 100svh;
}
#YMK-module-wrapper {
  width: 100vw;
  height: 100svh;
  position: relative;
}

/* TODO: debug用の要素のため不要になれば削除 */
.failed-checkbox-container {
  position: absolute;
  top: 85px;
  left: 10px;
  background: #fff;
  z-index: 30;
}

#YMK-module {
  position: absolute;
  width: 100%;
  height: 100%;
}

.skin-age-label {
  height: 32px;
  width: 32px;
  position: absolute;
  bottom: 0;
  left: 0;
  color: #ffffff;
  font-style: Noto sans JP;
  font-size: 12px;
  font-weight: bold;
  text-align: right;
}
.skin-age {
  height: 32px;
  width: 32px;
  position: absolute;
  bottom: 7px;
  left: 44px;
  color: #ffffff;
  font-style: Roboto;
  font-size: 40px;
  font-weight: 500;
}

/* 肌分析後のインジケーター表示 */
.feature-indicator-container-wrapper {
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 10;
}
.feature-indicator-container {
  width: 120px;
  height: 400px;
  position: relative;
}

/* インジケーター表示共通 */
.indicator-upper-img {
  height: 32px;
  width: calc((32px * var(--ratio)));
  position: absolute;
  top: 0;
  right: 0;

  background-size: contain;

  /* default value */
  --ratio: calc(369 / 99);
}
.indicator-bottom-label-1 {
  position: absolute;
  top: 40px;
  right: 14px;

  text-align: right;
  font-style: Noto sans JP;
  font-size: 11px;
  font-weight: Regular;
  color: #ffffff;
}

.indicator-bottom-label-2 {
  position: absolute;
  top: 275px;
  right: 14px;

  font-style: Noto sans JP;
  font-size: 11px;
  font-weight: Regular;
  color: #ffffff;
}
.indicator-bottom-img {
  height: 210px;
  width: calc((210px * 54 / 498));
  position: absolute;
  top: 60px;
  right: 12px;
  background-size: contain;
  background-repeat: no-repeat;
}
/* 分割したインジケーターの配置位置 */
.indicator-bottom-img-1 {
  height: 90px;
  width: calc((90px * 54 / 213));
  position: absolute;
  top: 60px;
  right: 12px;
  background-size: contain;
  background-repeat: no-repeat;
}
.indicator-bottom-img-2 {
  height: 90px;
  width: calc((90px * 54 / 213));
  position: absolute;
  top: 180px;
  right: 12px;
  background-size: contain;
  background-repeat: no-repeat;
}

/* ハリ */
.firmness-indicator-upper-img {
  background-image: var(--firmness-indicator-upper-img);
}
.firmness-indicator-bottom-img {
  background-image: url("../assets/images/0_indicator_bottom.png");
}
/* 乾燥小じわ */
.wrinkles-indicator-upper-img {
  background-image: var(--wrinkles-indicator-upper-img);
}
.wrinkles-indicator-bottom-img {
  background-image: url("../assets/images/1_indicator_bottom.png");
}
/* 目もとの明るさ */
.darkCirclesV2-indicator-upper-img {
  background-image: var(--darkCirclesV2-indicator-upper-img);
}
/* 毛穴の目立ち */
.pore-indicator-upper-img {
  background-image: var(--pore-indicator-upper-img);
}
.pore-indicator-bottom-img {
  background-image: url("../assets/images/3_indicator_bottom.png");
}
/* なめらかさ */
.texture-indicator-upper-img {
  background-image: var(--texture-indicator-upper-img);
}
.texture-indicator-bottom-img-1 {
  background-image: url("../assets/images/4_indicator_bottom_1.png");
}
.texture-indicator-bottom-img-2 {
  background-image: url("../assets/images/4_indicator_bottom_2.png");
}
/* 肌全体の明るさ */
.ageSpots-indicator-upper-img {
  background-image: var(--ageSpots-indicator-upper-img);
}
.ageSpots-indicator-bottom-img {
  background-image: url("../assets/images/5_indicator_bottom.png");
}
/* うるおい */
.moisture-indicator-upper-img {
  background-image: var(--moisture-indicator-upper-img);
}
.moisture-indicator-bottom-img {
  background-image: url("../assets/images/6_indicator_bottom.png");
}

/* 肌分析後のタブ表示 */
.skin-care-feature-tab-container {
  width: 100vw;
  position: absolute;
  bottom: var(--powered-by-perfect-height);
  z-index: 10;
}
.skin-care-feature-tab-list {
  height: var(--feature-tab-list-height);
  margin: 0;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: var(--feature-tab-padding-bottom);
  display: flex;
  justify-content: flex-start;
  list-style-type: none;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  gap: 12px;
}
.skin-care-feature-tab-list li {
  min-width: var(
    --feature-tab-button-side-length
  ); /* スクロールを有効にするために最小幅を指定 */
  height: 100%;
  background-size: contain;
  position: relative;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

/* 共通項目 */
.feature-tab-button {
  position: absolute;
  bottom: calc(
    var(--feature-tab-label-height) + var(--feature-tab-while-button-label)
  );
  left: 50%;
  transform: translate(-50%, 0);
  width: var(--feature-tab-button-side-length);
  height: var(--feature-tab-button-side-length);
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-style: Roboto;
  font-size: 28px;
  font-weight: bold;
}
.feature-tab-label {
  height: var(--feature-tab-label-height);
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal bold 9px/11px Noto Sans JP;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #00000029;
  opacity: 1;
}
.tab-item {
  position: relative;
}
/* ハリ */
.firmness-tab-button {
  background-image: url("../assets/images/0_unselected.png");
}
.firmness-tab-button.active {
  background-image: url("../assets/images/0_selected.png");
}
/* 乾燥小じわ */
.wrinkles-tab-button {
  background-image: url("../assets/images/1_unselected.png");
}
.wrinkles-tab-button.active {
  background-image: url("../assets/images/1_selected.png");
}
/* 目もとの明るさ */
.darkCirclesV2-tab-button {
  background-image: url("../assets/images/2_unselected.png");
}
.darkCirclesV2-tab-button.active {
  background-image: url("../assets/images/2_selected.png");
}
/* 毛穴の目立ち */
.pore-tab-button {
  background-image: url("../assets/images/3_unselected.png");
}
.pore-tab-button.active {
  background-image: url("../assets/images/3_selected.png");
}
/* なめらかさ */
.texture-tab-button {
  background-image: url("../assets/images/4_unselected.png");
}
.texture-tab-button.active {
  background-image: url("../assets/images/4_selected.png");
}
/* 肌全体の明るさ */
.ageSpots-tab-button {
  background-image: url("../assets/images/5_unselected.png");
}
.ageSpots-tab-button.active {
  background-image: url("../assets/images/5_selected.png");
}
/* うるおい */
.moisture-tab-button {
  background-image: url("../assets/images/6_unselected.png");
}
.moisture-tab-button.active {
  background-image: url("../assets/images/6_selected.png");
}

/* デバッグ用 */
.debug-tools-loading {
  z-index: 10000;
}
.debug-tools-score {
  padding: 16px;
}
.debug-tools-score button {
  font-size: 16px;
}
.debug-input-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.debug-input-container label {
  margin-right: 10px;
  font-size: 16px;
}
.debug-input-container select {
  font-size: 16px;
}
.app-link-button {
  /* Layout Properties */
  position: fixed;
  top: 4px;
  left: 0px;
  /* UI Properties */
  border: none;
  width: 62px;
  height: 38px;
  background: url("~@/assets/images/chart_button.png") no-repeat;
  background-size: cover;
  z-index: 100;
}
</style>
